import { createContext, ReactNode, useState, useEffect } from "react";

import { useCurrentAccount } from "@/hooks/useCurrentAccount";
import { getProfessionals } from "@/services/sintegrada/professional/getProfessionals";
import { User } from "@/@types/sintegrada/User";
import { HealthUnit } from "@/@types/esus/HealthUnit";
import { getHealthUnits } from "@/services/app/healthUnitService";

type ProfessionalContextType = {
	professionals: User[];
	healthUnits: HealthUnit[];
};

export const SIntegradaContext = createContext({} as ProfessionalContextType);

type SIntegradaContextProviderProps = {
	children: ReactNode;
};

export function SIntegradaContextProvider({ children }: SIntegradaContextProviderProps) {
	const [professionals, setProfessionals] = useState<User[]>([]);
	const [healthUnits, setHealthUnits] = useState<HealthUnit[]>([]);
	const { uf, ibgeCode, cnes, module } = useCurrentAccount();

	async function handleGetProfessionals() {
		if (!ibgeCode) return;
		setProfessionals(await getProfessionals({ uf, ibgeCode, cnes }));
	}

	async function handleGetHealthUnits() {
		if (!ibgeCode) return;
		setHealthUnits(await getHealthUnits({ uf, ibgeCode, cnes, module }));
	}

	useEffect(() => {
		handleGetProfessionals();
		handleGetHealthUnits();
		return () => {
			setProfessionals([]);
			setHealthUnits([]);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<SIntegradaContext.Provider value={{ professionals, healthUnits }}>
			{children}
		</SIntegradaContext.Provider>
	);
}
